import React ,{Component} from 'react';
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import dayjs, { Dayjs } from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { addDays } from "date-fns";
import Moment from 'react-moment';
import moment from 'moment';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import LogoutIcon from '@mui/icons-material/Logout';
import Collapse from '@mui/material/Collapse';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';


function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

const headCells = [

 { id: 'or_orderno', numeric: false, label: 'Invoice No.' },
  { id: 'or_name', numeric: false, label: 'Name' },
  { id: 'or_email', numeric: false, label: 'Email Id' },
  { id: 'or_phone', numeric: false, label: 'Phone No.' },  
{ id: 'cs_date', numeric: false, label: 'Date' },  
{ id: 'classtype', numeric: false, label: 'Preference' },  
  { id: 'sb_title', numeric: false, label: 'Duration' },
  { id: 'sm_slotname', numeric: false, label: 'Slot' },    
  { id: '', numeric: false,  label: '' },

]
function EnhancedTableHead(props) {
  const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};


const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 

  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});
export default class  Admincustomerpostpone extends Component {
	constructor(props) {
    super();
	
	 this.state = {custschedule:[],totalcnt:0,rowsPerPage:50,page: 0 ,prevpage:0,redirect:false,pagename:'',order:'desc' ,orderBy:'',name:'',csid:'',orid:'',smid:'',type:'',celldate:'',postponetype:'',cu_id:'',Branchdata:[],branchid:'',invoicedate:dayjs(Date.now()),invoicedate1:'',invoicetodate1:'',invoicetodate:dayjs(Date.now()),exportdata:[]}
	this.updateDonenewParent = this.updateDonenewParent;
	   
	}
	
	updateDonenewParent = (text) => {  this.ApiPostponecall(this.state.page,this.state.rowsPerPage); }
	
	myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  
   

  this.setState({[nam]: val});

}

componentDidMount() {
	
		document.title = "Atha yoga Living - No Show Report";  
	
			  
	if(localStorage.getItem("AYLuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Default'
          })
		  }
 

  this.ApiPostponecall(this.state.page,this.state.rowsPerPage); 
this.onloadBranch();
  this.ApiexportPostponecall();
	}
	ApiPostponecall(page,rowsPerPage){
		let strbranch=this.state.branchid;
	 if(localStorage.getItem("AYLrole")!=="1")
	 {
		 strbranch=localStorage.getItem("AYLbrid");
	 }	
  
  axios.get(Serverurl+'ajaxcustomerschedule.php?action=getpostpone&or_name='+this.state.name+'&StartIndex='+page+'&PageSize='+rowsPerPage+'&cs_postponeclass=4&or_bm_id='+strbranch+'&cs_date='+this.state.invoicedate1+'&cs_todate='+this.state.invoicetodate1)
  .then(resp => {  
		
    if(resp.data.length>0){

			this.setState({  
			  custschedule: resp.data,  
			   totalcnt:parseInt(resp.data[0].count),
			});	 
     }
	 else{
		   this.setState({custschedule:[],totalcnt:0});
	 }
   
    });

}
ApiexportPostponecall(){
		let strbranch=this.state.branchid;
	 if(localStorage.getItem("AYLrole")!=="1")
	 {
		 strbranch=localStorage.getItem("AYLbrid");
	 }	
  
  axios.get(Serverurl+'ajaxcustomerschedule.php?action=getpostpone&or_name='+this.state.name+'&cs_postponeclass=4&or_bm_id='+strbranch+'&cs_date='+this.state.invoicedate1+'&cs_todate='+this.state.invoicetodate1)
  .then(resp => {  
		
    if(resp.data.length>0){

			this.setState({  
			  exportdata: resp.data,  
			  
			});	 
     }
	 else{
		   this.setState({exportdata:[],totalcnt:0});
	 }
   
    });

}
	  
handdateChanges = (date) => {
	
	  var month="";
 var date1 = new Date(date);
var todate1 = new Date(date);
	 if((date1.getMonth() + 1)<10)
	 {
		month="0"+ (date1.getMonth() + 1)		 
	 }else{month=(date1.getMonth() + 1)}   
	 
	 todate1.setDate(date1.getDate() + 1);
	
     this.setState({ invoicedate:dayjs(date),
invoicedate1:date1.getFullYear() + '-' + month + '-' +date1.getDate(),
invoicetodate: todate1,
invoicetodate1:todate1.getFullYear() + '-' + month + '-' +todate1.getDate()
	 })
	
	
  }
  handtodateChanges = (date) => {
	
	  var month="";
 var date1 = new Date(date);

	 if((date1.getMonth() + 1)<10)
	 {
		month="0"+ (date1.getMonth() + 1)		 
	 }else{month=(date1.getMonth() + 1)}   
     this.setState({ invoicetodate:dayjs(date),
invoicetodate1:date1.getFullYear() + '-' + month + '-' +date1.getDate()
	 })
	
	
  }
onloadBranch()
{
	axios.post(Serverurl+'ajaxbranch.php?action=getall&sorting=bm_id')
  .then(resp => {  
		
  if(resp.data.length>0){
	  this.setState({Branchdata:resp.data,},()=>{
								let strbrid=this.state.branchid;

								if(resp.data.length===1 && strbrid!='')
								{
									strbrid=resp.data[0]["bm_id"];
								}
								 let BranchFromApi = this.state.Branchdata.map(row => {
                          
          return {value:row.bm_id,display:row.bm_name}
        });
      
		
        this.setState({branchid:strbrid,
          Branchdata: [{value: '0', display:'Select Branch'}].concat(BranchFromApi)
        });
								
							})


							
  }else{
	  this.setState({Branchdata:[]});
  }
   
  });
	
}
handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};

handleChangePage = (event, newPage) => {  

   
    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.ApiPostponecall(this.state.page,this.state.rowsPerPage);  });
   
 
    
  };   
  
  
   handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
  

   
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{ this.ApiPostponecall(this.state.page,this.state.rowsPerPage); }); 
	
	
  };
  
   
   
   onClickSearch=()=>{  
  
  this.ApiPostponecall(this.state.page,this.state.rowsPerPage);
  this.ApiexportPostponecall();
  } 
RescheduleRequest(csid,orid,classtype,celldate,cu_id){
	
	 let r = window.confirm("Do you really want to Re-Schedule?");
		 if(r == true){ //sign Out logic
		  this.setState({csid :csid,cu_id:cu_id,orid:orid,type:classtype,celldate:celldate},()=>{
			  
			  this.refs.Addschedulebox.handleClickOpen()}); 
		 }
 
 }
 
 //item.or_id,item.or_classtype,item.or_enddate
render() {

	if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    } 
  return (
  
  <React.Fragment>
   
 
 <div className="boxheading">
				
<h2>No Show Report</h2>

</div><div className="clear"></div>



 <div className="searchmaster"> 




<ul>
	{localStorage.getItem("AYLrole")==="1" && (
  <li>
<p>Select Branch</p>

<p>
<FormControl  className="stadrp">			   
			<Select
			className="txtbox"
			native
			value={this.state.branchid}
			onChange={this.myChangeHandler}
			name='branchid'
			
			fullwidth
			
			
			>
		
		
			{this.state.Branchdata.map(row => (
				<option  
            
				  value={row.value}
				>
				  {row.display}
				</option  >
			  ))}
			 </Select>
		</FormControl>
</p>
</li>
  )}
  <li>
 <p>From Date</p>

<p> <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.invoicedate) }
className="txtbox" 
    onChange={this.handdateChanges} format="DD/MM/YYYY"
/>  </DemoContainer>
    </LocalizationProvider>
</p>
 </li>
 
  <li>
 <p>To Date</p>

<p> <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.invoicetodate) }
className="txtbox" 
    onChange={this.handtodateChanges} format="DD/MM/YYYY"
/>  </DemoContainer>
    </LocalizationProvider>
</p>
 </li>
<li>
 
<p>Name/Email/Phone No.</p>
		<p><TextField
            variant="outlined"
            margin="normal"
            fullWidth value={this.state.name}
            id="name"
                inputProps={{tabIndex: "1",maxLength:150}} className="txtbox"
            name="name" onChange={this.myChangeHandler}
         
           
          /></p>
		
		</li>
		<li>
 
<p >
		<Button variant="contained" onClick={this.onClickSearch} className="frmSecondarybtn" endIcon={<SearchIcon />}>
        Search
      </Button> &nbsp;
	  
	  <ReactHTMLTableToExcel
							id="test-table-xls-button"
							className="frmSecondarybtn"
							table="leadmasterreport"
							filename="noshow Report"
							sheet="noshow Report"
							buttonText="EXPORT"/></p>
 </li>
 
 </ul>
</div>
<div className="clear"></div>


<Paper className={useStyles.root}>
  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table">  

					  
					   <EnhancedTableHead
             
              
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.custschedule.length}
            />
			
			
			
                      <TableBody>

                     {stableSort(this.state.custschedule, getSorting(this.state.order, this.state.orderBy)).map((item,index) =>{
 if(this.state.totalcnt>0)					
	 {  
 return ( <React.Fragment>
 <TableRow key={index} >

	
	 <TableCell>{item.or_orderno}</TableCell>

  <TableCell>{item.or_name}</TableCell>
<TableCell>{item.or_phone}</TableCell>
<TableCell>{item.or_email}</TableCell>
	<TableCell>{item.cs_date}</TableCell>
	<TableCell>{item.classtype}</TableCell>
<TableCell>{item.sb_title}</TableCell>	
	<TableCell>{item.sm_slotname}</TableCell>
	
	
	


 </TableRow>


				</React.Fragment>	
				);
	 }
						 else{
					 return ( <React.Fragment>
				<TableRow  >
<TableCell colspan="6">
<h3>No Records</h3>
</TableCell>
				</TableRow>
				</React.Fragment>	
				);	
				}
					})}
                      </TableBody>


</Table>
  </TableContainer> 
 <TablePagination  
        rowsPerPageOptions={[50,100,150,200,250,300]}
        component="div"  
        count={this.state.totalcnt}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onRowsPerPageChange={this.handleChangeRowsPerPage}   
      />    
  </Paper>
   
   
   
   
<div style={{"display":"none"}}>
  <Paper className={useStyles.root}>


  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table" id="leadmasterreport">  

					  
					   <EnhancedTableHead
             
              
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.exportdata.length}
            />
			
			
			
                      <TableBody>

                     {this.state.exportdata.map((item,index) =>{
 if(this.state.totalcnt>0)					
	 {  
 return ( <React.Fragment>
 <TableRow key={index} >

	
	 <TableCell>{item.or_orderno}</TableCell>

  <TableCell>{item.or_name}</TableCell>
<TableCell>{item.or_phone}</TableCell>
<TableCell>{item.or_email}</TableCell>
	<TableCell>{item.cs_date}</TableCell>
	<TableCell>{item.classtype}</TableCell>
<TableCell>{item.sb_title}</TableCell>	
	<TableCell>{item.sm_slotname}</TableCell>
	
	
	


 </TableRow>


				</React.Fragment>	
				);
	 }
						 else{
					 return ( <React.Fragment>
				<TableRow  >
<TableCell colspan="6">
<h3>No Records</h3>
</TableCell>
				</TableRow>
				</React.Fragment>	
				);	
				}
					})}
                      </TableBody>


</Table>
  </TableContainer> 
 <TablePagination  
        rowsPerPageOptions={[50,100,150,200,250,300]}
        component="div"  
        count={this.state.totalcnt}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onRowsPerPageChange={this.handleChangeRowsPerPage}   
      />    
  </Paper></div>
</React.Fragment>

		  );
  }	
   
   
  
  
  
  
	
}
